import React, { useRef } from "react";
import emailjs from "emailjs-com";

const ConsultationAreaForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_qcyb3i9", // Replace with your EmailJS Service ID
        "template_azgr4kc", // Replace with your EmailJS Template ID
        form.current,
        "1RXsJFuJBbikL5VTO" // Replace with your EmailJS User ID
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Email sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send email. Please try again.");
        }
      );
  };

  return (
    <div className="consultation-form-wrap">
      <h4 className="title">Free Consultation</h4>
      <form ref={form} onSubmit={sendEmail}>
        <div className="form-grp">
          <input type="text" name="user_name" placeholder="Name" required />
        </div>
        <div className="form-grp">
          <input type="email" name="user_email" placeholder="Email Address" required />
        </div>
        <div className="form-grp">
          <input type="text" name="user_phone" placeholder="Phone Number" required />
        </div>
        <div className="form-grp">
          <select name="user_subject" className="form-select" required>
            <option value="">Subject</option>
            <option value={"Logo Design"}>Logo Design</option>
            <option value={"Web Designing"}>Web Designing</option>
            <option value={"Brand Design"}>Brand Design</option>
            <option value={"Packaging Design"}>Packaging Design</option>
            <option value={"UI/UX Design"}>UI/UX Design</option>
            <option value={"Business Advertising"}>Business Advertising</option>
            <option value={"SEO"}>SEO</option>
            <option value={"Brand Strategy"}>Brand Strategy</option>
            <option value={"PPC"}>PPC</option>
            <option value={"Content Writing"}>Content Writing</option>
            <option value={"Social Campaigns"}>Social Campaigns</option>
            <option value={"Animation"}>Animation</option>
          </select>
        </div>
        <button className="btn" type="submit">
          Consultation
        </button>
      </form>
    </div>
  );
};

export default ConsultationAreaForm;
